<template>
    <div class="panel">
        <h3>Debug</h3>

        <div>
            <Checkbox v-model="data.log" density="compact"> Log to Dev tools (F12) </Checkbox>
        </div>
    </div>
</template>

<script lang="ts">
    import { defineComponent, PropType } from 'vue';
    import { FakeData, DevPanelPage } from '../DevPanel.interfaces';
    import { isCheckoutPage } from '@/helpers/url';
    import Checkbox from '@ui/components/FormV2/Fields/Checkbox/Checkbox.vue';

    export default defineComponent({
        name: 'DebugPanel',
        components: { Checkbox },
        methods: { isCheckoutPage },
        props: {
            data: { type: Object as PropType<FakeData>, required: true },
            page: { type: String as PropType<DevPanelPage>, required: true },
        },
    });
</script>

<style lang="scss">
    @forward './Panel.scss';
</style>
